(function () {
    //banner滚动开始
    var mySwiper = new Swiper("#homeBanner", {
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
        preloadImages: false,
        lazy: true,
    });

    $("#homeBanner").hover(function () { //滑过悬停
        mySwiper.autoplay.stop();
    }).mouseleave(function () { //离开开启
        mySwiper.autoplay.start();
    });


    new Swiper("#aboutBanner", {
        pagination: {
            el: ".swiper-pagination",
        },
        autoplay: {
            delay: 5000,
        },
        preloadImages: false,
        lazy: true,
    });
    //banner滚动结束


})();
